import { render, staticRenderFns } from "./svgWechat.vue?vue&type=template&id=3d43b054&scoped=true"
import script from "./svgWechat.vue?vue&type=script&lang=js"
export * from "./svgWechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d43b054",
  null
  
)

export default component.exports